import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';
import { property as base } from './base';
import { property as AT } from './AT';
import { property as CZ } from './CZ';
import { property as HR } from './HR';
import { property as HU } from './HU';
import { property as RO } from './RO';
import { property as SK } from './SK';

export const propertyConfig: InsuranceIndex<PropertyFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
};
